module.exports = __webpack_public_path__ + "img/odrive.3f669634.png";